export default "__VITE_ASSET__CnAVya0u__"